const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobalMacroLogoBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "130 50 400 175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M294.79,138.43c-2.46.6-5.13.9-8.03.9s-5.77-.48-8.29-1.43c-2.53-.95-4.7-2.3-6.52-4.03-1.82-1.73-3.24-3.81-4.27-6.23-1.03-2.42-1.54-5.11-1.54-8.08s.52-5.72,1.56-8.16c1.04-2.44,2.48-4.51,4.32-6.23,1.84-1.71,3.99-3.03,6.47-3.95,2.47-.92,5.14-1.38,8-1.38s5.72.45,8.27,1.35c2.54.9,4.61,2.11,6.2,3.63l-5.72,6.52c-.88-1.02-2.05-1.86-3.5-2.52-1.45-.65-3.09-.98-4.93-.98-1.59,0-3.06.29-4.4.87s-2.51,1.4-3.5,2.44c-.99,1.04-1.76,2.28-2.31,3.71-.55,1.43-.82,2.99-.82,4.69s.25,3.32.74,4.77c.49,1.45,1.23,2.69,2.2,3.74.97,1.04,2.17,1.85,3.6,2.44,1.43.58,3.06.87,4.9.87,1.06,0,2.07-.08,3.02-.24.95-.16,1.84-.42,2.65-.77v-6.84h-7.16v-7.31h15.48v19.88c-1.84.95-3.98,1.73-6.44,2.33Z",
    style: {
      fill: "#264c9a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.44,138.38v-37.52h9.12v29.63h14.52v7.9h-23.64Z",
    style: {
      fill: "#264c9a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.64,119.46c0,2.97-.51,5.68-1.54,8.14-1.03,2.46-2.45,4.56-4.27,6.31-1.82,1.75-3.98,3.1-6.49,4.05-2.51.95-5.23,1.43-8.16,1.43s-5.64-.48-8.14-1.43c-2.49-.95-4.65-2.31-6.47-4.05-1.82-1.75-3.24-3.85-4.27-6.31-1.03-2.46-1.54-5.17-1.54-8.14s.51-5.71,1.54-8.14c1.02-2.42,2.45-4.48,4.27-6.17,1.82-1.7,3.97-3,6.47-3.92,2.49-.92,5.2-1.38,8.14-1.38s5.65.46,8.16,1.38c2.51.92,4.67,2.23,6.49,3.92,1.82,1.7,3.24,3.75,4.27,6.17,1.02,2.42,1.54,5.13,1.54,8.14ZM379.94,119.46c0-1.62-.26-3.14-.79-4.56-.53-1.41-1.26-2.62-2.2-3.63-.94-1.01-2.07-1.8-3.39-2.39s-2.78-.87-4.37-.87-3.04.29-4.35.87c-1.31.58-2.44,1.38-3.39,2.39-.95,1.01-1.69,2.22-2.2,3.63-.51,1.41-.77,2.93-.77,4.56s.26,3.26.79,4.69,1.26,2.66,2.2,3.68c.94,1.02,2.06,1.83,3.37,2.41,1.31.58,2.76.87,4.35.87s3.04-.29,4.35-.87c1.31-.58,2.44-1.39,3.39-2.41.95-1.02,1.7-2.25,2.23-3.68s.79-2.99.79-4.69Z",
    style: {
      fill: "#264c9a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.67,127.46c0,2.05-.41,3.77-1.22,5.17-.81,1.4-1.89,2.52-3.23,3.37-1.34.85-2.87,1.46-4.58,1.83s-3.47.56-5.27.56h-14.95v-37.52h14.95c1.45,0,2.93.15,4.45.45,1.52.3,2.9.81,4.13,1.54,1.24.72,2.24,1.71,3.02,2.94.78,1.24,1.17,2.81,1.17,4.72,0,2.08-.57,3.81-1.7,5.17-1.13,1.36-2.62,2.34-4.45,2.94v.11c1.06.18,2.06.5,3,.98.94.48,1.75,1.09,2.44,1.83.69.74,1.24,1.61,1.64,2.6.41.99.61,2.1.61,3.34ZM422.39,111.72c0-1.27-.49-2.2-1.46-2.78-.97-.58-2.41-.87-4.32-.87h-4.45v7.74h4.88c1.7,0,3.01-.34,3.95-1.03.94-.69,1.4-1.7,1.4-3.05ZM423.61,126.61c0-1.55-.58-2.63-1.75-3.23-1.17-.6-2.72-.9-4.66-.9h-5.04v8.59h5.09c.71,0,1.44-.06,2.2-.19.76-.12,1.45-.34,2.07-.66s1.12-.77,1.51-1.35.58-1.33.58-2.25Z",
    style: {
      fill: "#264c9a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.89,138.38l-2.92-7.37h-14.52l-2.76,7.37h-9.86l15.74-37.52h8.8l15.58,37.52h-10.07ZM461.82,110.87l-4.77,12.88h9.43l-4.66-12.88Z",
    style: {
      fill: "#264c9a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.88,138.38v-37.52h9.12v29.63h14.52v7.9h-23.64Z",
    style: {
      fill: "#264c9a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.98,181.69h.11l11.08-28.83h8.16v37.52h-5.25v-31.38h-.11l-12.46,31.38h-3.34l-12.4-31.38h-.11v31.38h-5.09v-37.52h8.16l11.24,28.83Z",
    style: {
      fill: "#264c9a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.81,190.38h-5.83l16.27-37.52h4.77l16.11,37.52h-5.94l-3.82-9.22h-17.81l-3.76,9.22ZM337.43,176.55h14.04l-7-17.6-7.05,17.6Z",
    style: {
      fill: "#264c9a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.01,184.55c-1.48,2.01-3.41,3.65-5.78,4.9-2.37,1.25-5.21,1.88-8.53,1.88-2.86,0-5.5-.49-7.92-1.46-2.42-.97-4.5-2.33-6.25-4.08s-3.12-3.83-4.11-6.25c-.99-2.42-1.48-5.08-1.48-7.98s.5-5.61,1.51-8.03c1.01-2.42,2.4-4.49,4.19-6.2,1.78-1.71,3.9-3.05,6.33-4,2.44-.95,5.09-1.43,7.95-1.43,1.27,0,2.56.12,3.87.37,1.31.25,2.56.62,3.76,1.11,1.2.5,2.3,1.1,3.29,1.83.99.72,1.84,1.56,2.54,2.52l-4.13,3.18c-.92-1.27-2.22-2.32-3.9-3.15-1.68-.83-3.49-1.25-5.43-1.25-2.19,0-4.16.4-5.91,1.19-1.75.79-3.24,1.88-4.48,3.26-1.24,1.38-2.19,2.98-2.86,4.8-.67,1.82-1.01,3.75-1.01,5.8s.33,4.1.98,5.94c.65,1.84,1.59,3.44,2.81,4.8,1.22,1.36,2.7,2.43,4.45,3.21,1.75.78,3.7,1.17,5.86,1.17s4.04-.42,5.78-1.27,3.16-2.08,4.29-3.71l4.19,2.86Z",
    style: {
      fill: "#264c9a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.44,190.38h-5.25v-37.52h12.03c1.8,0,3.52.19,5.14.56,1.62.37,3.05.96,4.27,1.78,1.22.81,2.18,1.88,2.89,3.21.71,1.32,1.06,2.94,1.06,4.85,0,2.76-.85,4.98-2.54,6.68s-3.89,2.77-6.57,3.23l10.49,17.23h-6.36l-9.54-16.69h-5.62v16.69ZM437.44,169.29h6.04c1.24,0,2.38-.11,3.44-.32,1.06-.21,1.99-.56,2.78-1.03.79-.48,1.42-1.09,1.88-1.85.46-.76.69-1.7.69-2.84s-.23-2.08-.69-2.84c-.46-.76-1.07-1.37-1.83-1.83-.76-.46-1.65-.79-2.68-.98-1.03-.19-2.1-.29-3.23-.29h-6.41v11.98Z",
    style: {
      fill: "#264c9a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.41,171.57c0,2.9-.5,5.56-1.51,7.98-1.01,2.42-2.39,4.5-4.16,6.25-1.77,1.75-3.87,3.11-6.31,4.08-2.44.97-5.09,1.46-7.95,1.46s-5.5-.49-7.92-1.46c-2.42-.97-4.51-2.33-6.28-4.08-1.77-1.75-3.15-3.83-4.13-6.25-.99-2.42-1.48-5.08-1.48-7.98s.49-5.61,1.48-8.03c.99-2.42,2.37-4.49,4.13-6.2,1.77-1.71,3.86-3.05,6.28-4,2.42-.95,5.06-1.43,7.92-1.43s5.51.48,7.95,1.43c2.44.95,4.54,2.29,6.31,4,1.77,1.71,3.15,3.78,4.16,6.2,1.01,2.42,1.51,5.1,1.51,8.03ZM510.74,171.57c0-2.05-.34-3.98-1.01-5.8-.67-1.82-1.63-3.42-2.86-4.8-1.24-1.38-2.73-2.46-4.48-3.26-1.75-.8-3.72-1.19-5.91-1.19s-4.11.4-5.86,1.19c-1.75.79-3.23,1.88-4.45,3.26-1.22,1.38-2.17,2.98-2.84,4.8-.67,1.82-1.01,3.75-1.01,5.8s.33,4.05,1.01,5.88c.67,1.84,1.62,3.44,2.86,4.8,1.24,1.36,2.72,2.43,4.45,3.21,1.73.78,3.67,1.17,5.83,1.17s4.12-.39,5.88-1.17c1.77-.78,3.27-1.85,4.5-3.21,1.24-1.36,2.19-2.96,2.86-4.8.67-1.84,1.01-3.8,1.01-5.88Z",
    style: {
      fill: "#264c9a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.69,104.8c-2.01,4.7-3.35,9.19-7.14,12.87-3.98,3.87-7.62,5.55-9.53,11.12-3.25,9.5-5.65,22.05-16.29,26.16-10.32,3.98-16.31-9.4-9.17-16.33,3.77-3.66,9.65-3.66,14.23-5.84,4.21-2.01,9.17-5.51,11.2-9.87,2.07-4.44-.21-9.46,1.01-14.06,1.27-4.77,5.73-9.15,10.11-11.22,8.06-3.8,17.89-1.06,19.51,8.31.95,5.47,1.24,10.33,4.66,14.99,3.13,4.27,7.54,6.99,12.18,9.36,4.09,2.09,7.84,4.27,8.76,9.2.88,4.74-1.7,9.61-6.13,11.5-4.53,1.93-9.84.35-12.44-3.86-2.85-4.61-.53-10.07-2.02-15.08-1.79-6.03-6.46-9.42-10.98-13.38-4.45-3.9-7.79-13.83-7.96-13.87Z",
    style: {
      fill: "#264c9a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.86,124.21c6.45.05,11.35,5.92,10.52,12.25-1.03,7.93-8.06,8.33-13.97,10.97-12.41,5.55-13.06,21.99-1.76,29.18,4.7,2.99,13.52,5.6,12.19,12.9-1.21,6.63-10.22,7.55-13.67,2.3-4.11-6.24-3.83-14.33-9.89-19.51-4.11-3.52-13.23-5.78-8.11-12.3,2.5-3.19,6.1-5.34,8.56-8.64,2.4-3.24,3.94-6.86,4.53-10.86,1.07-7.27,1.76-16.37,11.6-16.3Z",
    style: {
      fill: "#264c9a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.41,158.66c-.19.63-.52,1.2-.99,1.66-3.92,3.9-11.09,3.06-16.16,3.64-3.94.45-7.77.94-11.44,2.54-3.22,1.41-5.76,3.69-8.78,5.41-5.46,3.1-12.14,2.84-15.77-2.85-3.3-5.18-1.37-12.75,4.57-14.96,6.77-2.52,11.32,3.48,17.32,5.17,6.56,1.85,14-.36,19.24-4.54,2.62-2.09,4.6-4.77,6.46-7.55,2.16-3.24,6.75-9.07,6.75-9.07,0,0,2.02,10.12-1.2,20.54Z",
    style: {
      fill: "#264c9a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.73,195.15c2.09-15.7,18.49-28.04,34.03-23.34-3.9,6.23-9.05,11.88-14.6,15.35-5.05,3.15-9.36,5.88-19.43,7.99Z",
    style: {
      fill: "#264c9a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.62,130.72c-3.79-1.22-10.3-4.09-14.2-5.3-3.97-1.24-7.64-2.49-10.75-5.39-5.91-5.51-5.27-13.04-4.11-20.37,6.19,2.47,12.67,6.63,17.3,11.61,5.14,4.88,9.76,12.84,11.76,19.45Z",
    style: {
      fill: "#264c9a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.6,164.61c14.77-1.34,25.42,12.66,25,26.31-10.39-4.32-21.21-15.72-25-26.31Z",
    style: {
      fill: "#264c9a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.94,129.07c3.23-9.59,11.5-20.08,21.17-25.74.67,11.84-7.2,26.64-21.17,25.74Z",
    style: {
      fill: "#264c9a",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalMacroLogoBlue);
export default __webpack_public_path__ + "static/media/global-macro-logo-blue.e42b8339d3b568b065c1b2f20406d47f.svg";
export { ForwardRef as ReactComponent };